<!-- LpSimuleCompre -->
<div *ngIf="componenteLPSP == true">
  <app-landing-page-simulador-preco></app-landing-page-simulador-preco>
  <!-- Exibe o componente LpSimuleCompreComponent -->
</div>

<!-- banner -->
<ng-container *ngIf="componenteLPSP == false" #bannerContent>
  <div
    class="header-left mobile-none"
    style="margin-bottom: -97px"
    *ngIf="ehLPSimuladorPreco"
  >
    <div
      class="site-logo"
      style="
        box-shadow: rgba(0, 0, 0, 0.09) 0px 2px 1px,
          rgba(0, 0, 0, 0.09) 0px 4px 2px, rgba(0, 0, 0, 0.09) 0px 8px 4px,
          rgba(0, 0, 0, 0.09) 0px 16px 8px, rgba(0, 0, 0, 0.09) 0px 32px 16px;
      "
    >
      <div class="figure">
        <img
          class="img-geia-top image-main"
          src="../../../../assets/app-assets/images/logo/logo-b-geia.png"
          style="margin-left: 30px; margin-top: 15px; margin-bottom: 9px"
        />
      </div>
    </div>
  </div>
  <div
    *ngIf="exibirPublicacao; else foraDoHorario"
    class="row banner-bg"
    style="
      margin-bottom: 11.8rem !important;
      background-image: url('../../../../../assets/app-assets/images/fotografias/varejo/background.png');
      background-size: cover;
      background-position: center;
    "
  >
    <!-- Div da imagem do homem -->
    <div
      class="col-md-6"
      style="align-items: center; justify-content: center; margin-left: -6rem"
    >
      <img
        src="../../../../../assets/app-assets/images/fotografias/varejo/homem-unidemedFesp.png"
        alt="campanha marco"
        class="unimedFesp"
      />
    </div>

    <!-- Div dos promo marco
       -->
    <div
      class="col-md-6 col-sm-12 text-promo-marco"
      style="padding: 6vh; margin-top: 0rem !important; margin-bottom: 12vh"
    >
      <div
        class="text-section margin-text order-md-2 mobile bg-mobile bg-mobile-promo-marco"
      >
        <h1 class="title mb-1">
          <p class="" style="color: #fff !important">PLANOS DE SAÚDE</p>
        </h1>
        <h1 class="title">
          <p style="color: #149653 !important; font-weight: 600 !important">
            ISENÇÃO DE CARÊNCIA*
          </p>
        </h1>
        <h1 class="subtitle mb-1">
          <p style="color: #fff !important">PARA CONSULTAS E EXAMES SIMPLES*</p>
        </h1>

        <p class="subtitle mb-1" style="color: #fff !important">
          Descubra o preço do seu plano informando apenas sua
          <span>idade, cidade e profissão.</span>
        </p>

        <p class="subtitle" style="color: #fff !important">
          *CAMPANHA VÁLIDA PARA CONTRATAÇÃO ENTRE <br />
          O DIA 01/03 A 30/04.
          <span style="color: #149653 !important">
            CONSULTE O REGULAMENTO. </span
          ><br />
        </p>
        <br />
        <div
          class="div-button-promo-marco btn-group botoes-centralizado-black-friday-2024"
        >
          <button
            style="
              background-color: #407590 !important;
              height: 4rem !important;
            "
            (click)="
              simularPorOperadora(
                template,
                menorValorSaude?.IdOperadora,
                menorValorSaude?.NomeOperadora,
                'saude'
              )
            "
            type="button"
            class="btn template-btn round box-shadow-4 btn-simule mb-5 botao-simule-black-friday-2024 largura-botoes-black-friday-2024"
          >
            <span>SIMULAR AGORA</span>
          </button>
          <a
            href="https://api.whatsapp.com/send?phone=551136602000&text=Olá Géia, estou precisando contratar um Plano de Saúde bom e barato!"
            target="_blank"
          >
            <button
              type="button"
              class="btn btn-float btn-simule btn-success round box-shadow-4 col-sm-12 largura-botoes-black-friday-2024"
              style="height: 4rem !important"
            >
              <span>FALE COM UM CONSULTOR</span>
            </button>
          </a>
        </div>
      </div>
    </div>
  </div>

  <section
    *ngIf="exibirPublicacao"
    class="cards-section-novo-banner-iris d-flex justify-content-center align-items-center"
  >
    <div class="container">
      <div class="scroll-card-iris cards">
        <div class="card round-top">
          <div class="card-body">
            <h5 class="card-title">Reajustes Contratuais Abaixo do Mercado</h5>
            <p class="card-text">Proteja seu bolso com aumentos menores.</p>
          </div>
        </div>

        <div class="card round-top">
          <div class="card-body">
            <h5 class="card-title">Tradição e Confiança</h5>
            <p class="card-text">Anos de experiência cuidando da sua saúde.</p>
          </div>
        </div>
        <div class="card round-top">
          <div class="card-body">
            <h5 class="card-title">Cobertura Completa</h5>
            <p class="card-text">
              Atendimento médico de qualidade quando você mais precisa.
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
</ng-container>

<ng-template #foraDoHorario>
  <!-- BANNER SAUDE START -->
  <ng-container *ngIf="componenteLPSP == false" #bannerContent>
    <div
      class="header-left mobile-none"
      style="margin-bottom: -97px"
      *ngIf="ehLPSimuladorPreco"
    >
      <div
        class="site-logo"
        style="
          box-shadow: rgba(0, 0, 0, 0.09) 0px 2px 1px,
            rgba(0, 0, 0, 0.09) 0px 4px 2px, rgba(0, 0, 0, 0.09) 0px 8px 4px,
            rgba(0, 0, 0, 0.09) 0px 16px 8px, rgba(0, 0, 0, 0.09) 0px 32px 16px;
        "
      >
        <div class="figure">
          <img
            class="img-geia-top image-main"
            src="../../../../assets/app-assets/images/logo/logo-b-geia.png"
            style="margin-left: 30px; margin-top: 15px; margin-bottom: 30px"
          />
        </div>
      </div>
    </div>
    <div
      class="row campo-superior altura-div-central"
      style="margin-top: 65px; background-color: #fff"
    >
      <div class="container justify-content-center align-items-center">
        <div class="col-md-12 col-sm-12 campo-texto">
          <div
            class="text-section margin-text text-center order-md-2 mobile altura-campo-texto-1024"
          >
            <h1 class="title espacamento-texto-parte-um-black-friday-2024">
              BUSCANDO UM
              <span class="title-banner title preto-geia"> PLANO DE SAÚDE</span>
              COM AMPLA
            </h1>
            <h1 class="title mt-1 espacamento-texto-parte-um-black-friday-2024">
              COBERTURA E BAIXOS REAJUSTES?
            </h1>

            <p
              class="subtitle text-center"
              style="margin-top: 20px; margin-bottom: 20px"
            >
              Descubra o preço do seu plano informando <br />apenas sua
              <span class="preto-geia">idade, cidade e profissão.</span>
            </p>

            <div class="btn-group mt-2 botoes-centralizado-black-friday-2024">
              <button
                style="
                  background-color: #407590 !important;
                  height: 4rem !important;
                "
                (click)="
                  simularPorOperadora(
                    template,
                    menorValorSaude?.IdOperadora,
                    menorValorSaude?.NomeOperadora,
                    'saude'
                  )
                "
                type="button"
                class="btn template-btn round box-shadow-4 btn-simule mb-3 botao-simule-black-friday-2024 largura-botoes-black-friday-2024"
              >
                <span>SIMULAR AGORA</span>
              </button>
              <a
                href="https://api.whatsapp.com/send?phone=551136602000&text=Olá Géia, estou precisando contratar um Plano de Saúde bom e barato!

            "
                target="_blank"
              >
                <button
                  type="button"
                  class="btn btn-float btn-simule btn-success round box-shadow-4 col-sm-12 largura-botoes-black-friday-2024"
                  style="height: 4rem !important"
                >
                  <span>FALE COM UM CONSULTOR</span>
                </button>
              </a>
            </div>
          </div>
        </div>

        <div class="logos-container">
          <img
            src="../../../../../assets/app-assets/images/logos-empresas/externos/unimedfesp.png"
            alt="unimed fesp"
            class=""
          />
          <img
            style="height: 144px !important"
            src="../../../../../assets/app-assets/images/logos-empresas/externos/prevent-senior.png"
            alt="prevent senior"
          />
          <img
            src="../../../../../assets/app-assets/images/logos-empresas/externos/plena-saude.png"
            alt="plena"
            class=" "
          />
          <img
            style="height: 144px !important"
            src="../../../../../assets/app-assets/images/logos-empresas/externos/logo-hapvida.png"
            alt="logo-hapvida"
          />
          <img
            src="../../../../../assets/app-assets/images/logos-empresas/externos/amil.png"
            alt="amil"
            class=" "
          />
          <img
            src="../../../../../assets/app-assets/images/logos-empresas/externos/notredame.png"
            alt="notre dame"
            class=" "
          />
          <img
            src="../../../../../assets/app-assets/images/logos-empresas/externos/med-senior.png"
            alt="med senior"
            class=" "
          />
        </div>
      </div>
    </div>
    <section
      class="cards-section-novo-banner-iris d-flex justify-content-center align-items-center"
      style="margin-top: -42vh"
    >
      <div class="container" style="background-color: #ffffff">
        <div class="scroll-card-iris cards">
          <div class="card card-banner round-top">
            <div class="card-body">
              <h5 class="card-title">
                Reajustes Contratuais Abaixo do Mercado
              </h5>
              <p class="card-text">Proteja seu bolso com aumentos menores.</p>
            </div>
          </div>

          <div class="card card-banner round-top">
            <div class="card-body">
              <h5 class="card-title">Tradição e Confiança</h5>
              <p class="card-text">
                Anos de experiência cuidando da sua saúde.
              </p>
            </div>
          </div>
          <div class="card card-banner round-top">
            <div class="card-body">
              <h5 class="card-title">Cobertura Completa</h5>
              <p class="card-text">
                Atendimento médico de qualidade quando você mais precisa.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  </ng-container>
</ng-template>
<!-- BANNER SAUDE END -->

<ng-template #template>
  <div class="modal-body text-center">
    <app-politica-privacidade></app-politica-privacidade>
  </div>
</ng-template>
<section style="margin-top: -10px" *ngIf="ehLPSimuladorPreco">
  <app-portal-footer></app-portal-footer>
</section>
